// Fragment "pathwaysMaterials": the practitioner's side of Pathways v3 (contract §9), part
// 2: the step editor (admin/pathways/StepEditorModal.jsx: title, duration, the Video /
// Reading / Practice / Quiz (with its course-quiz import) / Live session / Course panels of
// contract §10.11, downloadable resources), and the words of the media picker's
// non-image modes (admin/MediaPickerModal.jsx `accept="video" | "pdf" | "resource"`,
// plus the image mode's `wrongType` and the per-item `selectNamed` label). The image
// mode's historical words stay in ./media.js. Merged in ./index.js.
export default {
  fr: {
    // ── step editor ──
    "path.editor.newTitle": "Nouvelle étape",
    "path.editor.editTitle": "Modifier l'étape",
    "path.editor.close": "Fermer",
    "path.editor.title": "Titre",
    "path.editor.duration": "Durée (min)",
    "path.editor.kind": "Type de contenu",
    "path.editor.save": "Enregistrer l'étape",
    "path.editor.cancel": "Annuler",
    "path.editor.confirmDiscard": "Fermer sans garder les modifications de cette étape ?",
    "path.editor.remove": "Retirer",
    "path.editor.removeFile": "Retirer {name}",
    "path.editor.unnamedFile": "Fichier",
    "path.editor.resources": "Ressources téléchargeables",
    "path.editor.resourcesOptional": "(facultatif)",
    "path.editor.attachFiles": "Joindre des fichiers",
    "path.editor.video.uploadOrLink": "Importez une vidéo ou collez un lien",
    "path.editor.video.upload": "Choisir ou importer une vidéo",
    "path.editor.video.uploaded": "Vidéo importée",
    "path.editor.video.link": "ou collez un lien YouTube ou Vimeo",
    "path.editor.video.preview": "Aperçu de la vidéo",
    "path.editor.video.autoComplete": "Validée automatiquement à 90 % de visionnage",
    "path.editor.reading.mode": "Mode d'édition",
    "path.editor.reading.write": "Écrire",
    "path.editor.reading.preview": "Aperçu",
    "path.editor.reading.previewEmpty": "Rien à afficher pour l'instant.",
    "path.editor.reading.toolbar": "Mise en forme",
    "path.editor.reading.body": "Texte de la lecture",
    "path.editor.reading.tool.bold": "Gras",
    "path.editor.reading.tool.italic": "Italique",
    "path.editor.reading.tool.heading": "Titre",
    "path.editor.reading.tool.bullets": "Liste à puces",
    "path.editor.reading.tool.link": "Lien",
    "path.editor.reading.or": "ou",
    "path.editor.reading.attachPdf": "Joindre un PDF",
    "path.editor.reading.markDone": "L'apprenant touche « Marquer comme fait »",
    "path.editor.kindLocked": "Le type d'une étape enregistrée ne change plus. Pour un autre type, retirez l'étape et ajoutez-en une nouvelle.",
    "path.editor.catalogueFailed": "La liste n'a pas pu être chargée.",
    "path.editor.practice.instructions": "Consignes",
    "path.editor.practice.placeholder": "Pratiquez cette séquence et notez ce que vous avez ressenti.",
    "path.editor.practice.requireSubmission": "Demander un envoi (texte ou photo)",
    "path.editor.practice.completesOnSubmit": "Validée quand l'apprenant envoie un texte ou une photo. L'envoi arrive dans votre file de relecture.",
    "path.editor.practice.completesOnDone": "L'apprenant touche « Marquer comme fait »",
    "path.editor.live.dateTime": "Date · heure",
    "path.editor.live.zone": "Dans votre fuseau horaire ({zone}). Chaque apprenant la voit dans le sien.",
    "path.editor.live.zoneLocal": "Dans votre fuseau horaire. Chaque apprenant la voit dans le sien.",
    "path.editor.live.sessionType": "Type de séance",
    "path.editor.live.chooseSessionType": "Choisir un type de séance",
    "path.editor.live.serviceOption": "{name} · {n} min",
    "path.editor.live.serviceUnavailable": "{name} (n'est plus proposé)",
    "path.editor.live.serviceUnnamed": "Type de séance",
    "path.editor.live.bookedSeparately": "réservée séparément",
    "path.editor.live.noServices": "Aucun type de séance actif. Créez-en un dans Réservations.",
    "path.editor.live.location": "Lieu ou accès (facultatif)",
    "path.editor.live.locationPh": "Lien Zoom envoyé par e-mail, Studio A…",
    "path.editor.live.completesOnAttendance": "Validée quand vous cochez la présence sur le tableau de bord du parcours.",
    "path.editor.live.completesOnBooking": "Validée quand la réservation est marquée comme terminée",
    "path.editor.course.pick": "Cours",
    "path.editor.course.choose": "Choisir un cours publié",
    "path.editor.course.option": "{title} · {n} leçons",
    "path.editor.course.none": "Aucun cours publié. Publiez un cours dans Formations pour l'ajouter ici.",
    "path.editor.course.locked": "Le cours d'une étape enregistrée ne change plus. Pour un autre cours, retirez l'étape et ajoutez-en une nouvelle.",
    "path.editor.course.missing": "Ce cours n'existe plus",
    "path.editor.course.paidWarning": "Les apprenants de ce parcours reçoivent ce cours gratuitement.",
    "path.editor.course.completes": "Validée quand l'apprenant a terminé toutes les leçons du cours.",
    "path.editor.quiz.import": "Importer depuis un quiz de cours",
    "path.editor.quiz.importChoose": "Choisir un quiz",
    "path.editor.quiz.importOption": "{course} · {quiz} ({n} questions)",
    "path.editor.quiz.importRun": "Importer",
    "path.editor.quiz.importNone": "Aucun de vos cours n'a de quiz à importer.",
    "path.editor.quiz.imported": "{n} questions ajoutées à la fin du quiz. C'est une copie : modifier le cours ne la change pas.",
    "path.editor.quiz.importedOne": "{n} question ajoutée à la fin du quiz. C'est une copie : modifier le cours ne la change pas.",
    "path.editor.quiz.importSkipped": "{n} questions ignorées (les questions ouvertes ne sont pas prises en charge)",
    "path.editor.quiz.importSkippedOne": "{n} question ignorée (les questions ouvertes ne sont pas prises en charge)",
    "path.editor.quiz.empty": "Aucune question pour l'instant.",
    "path.editor.quiz.questionN": "Q{n}.",
    "path.editor.quiz.questionPh": "Votre question…",
    "path.editor.quiz.removeQuestion": "Supprimer la question {n}",
    "path.editor.quiz.choicesOf": "Réponses de la question {n}",
    "path.editor.quiz.choiceN": "Réponse {n}",
    "path.editor.quiz.choicePh": "Réponse {n}",
    "path.editor.quiz.markCorrect": "La réponse {n} est la bonne",
    "path.editor.quiz.correct": "(bonne réponse)",
    "path.editor.quiz.removeChoice": "Retirer la réponse {n}",
    "path.editor.quiz.addChoice": "+ Ajouter une réponse",
    "path.editor.quiz.addQuestion": "Ajouter une question",
    "path.editor.quiz.threshold": "Seuil de réussite",

    // ── media picker, non-image modes ──
    "media.picker.selectNamed": "Choisir {name}",
    "media.picker.wrongType": "Ce fichier n'est pas une image. Il a été ajouté à votre médiathèque, mais pas à ce champ.",
    "media.picker.video.hint": "Choisissez une vidéo ou importez-en une nouvelle.",
    "media.picker.video.upload": "Importer une vidéo",
    "media.picker.video.empty": "Aucune vidéo dans votre médiathèque. Importez-en une ci-dessus.",
    "media.picker.video.wrongType": "Ce fichier n'est pas une vidéo. Il a été ajouté à votre médiathèque, mais pas à cette étape.",
    "media.picker.pdf.hint": "Choisissez un PDF ou importez-en un nouveau.",
    "media.picker.pdf.upload": "Importer un PDF",
    "media.picker.pdf.empty": "Aucun PDF dans votre médiathèque. Importez-en un ci-dessus.",
    "media.picker.pdf.wrongType": "Ce fichier n'est pas un PDF. Il a été ajouté à votre médiathèque, mais pas à cette lecture.",
    "media.picker.resource.hint": "Choisissez un document ou une image, ou importez un nouveau fichier.",
    "media.picker.resource.upload": "Importer un fichier",
    "media.picker.resource.empty": "Aucun document dans votre médiathèque. Importez-en un ci-dessus.",
    "media.picker.resource.wrongType": "Ce type de fichier ne peut pas être proposé au téléchargement (PDF, Word, Excel, PowerPoint, texte ou image).",
  },
  en: {
    // ── step editor ──
    "path.editor.newTitle": "New step",
    "path.editor.editTitle": "Edit step",
    "path.editor.close": "Close",
    "path.editor.title": "Title",
    "path.editor.duration": "Duration (min)",
    "path.editor.kind": "Content type",
    "path.editor.save": "Save step",
    "path.editor.cancel": "Cancel",
    "path.editor.confirmDiscard": "Close without keeping the changes to this step?",
    "path.editor.remove": "Remove",
    "path.editor.removeFile": "Remove {name}",
    "path.editor.unnamedFile": "File",
    "path.editor.resources": "Downloadable resources",
    "path.editor.resourcesOptional": "(optional)",
    "path.editor.attachFiles": "Attach files",
    "path.editor.video.uploadOrLink": "Upload or paste link",
    "path.editor.video.upload": "Choose or upload a video",
    "path.editor.video.uploaded": "Uploaded video",
    "path.editor.video.link": "or paste a YouTube or Vimeo link",
    "path.editor.video.preview": "Video preview",
    "path.editor.video.autoComplete": "Auto-complete at 90% watched",
    "path.editor.reading.mode": "Editing mode",
    "path.editor.reading.write": "Write",
    "path.editor.reading.preview": "Preview",
    "path.editor.reading.previewEmpty": "Nothing to show yet.",
    "path.editor.reading.toolbar": "Formatting",
    "path.editor.reading.body": "Reading text",
    "path.editor.reading.tool.bold": "Bold",
    "path.editor.reading.tool.italic": "Italic",
    "path.editor.reading.tool.heading": "Heading",
    "path.editor.reading.tool.bullets": "Bulleted list",
    "path.editor.reading.tool.link": "Link",
    "path.editor.reading.or": "or",
    "path.editor.reading.attachPdf": "Attach PDF",
    "path.editor.reading.markDone": "Learner taps “Mark as done”",
    "path.editor.kindLocked": "A saved step keeps its type. For another type, remove the step and add a new one.",
    "path.editor.catalogueFailed": "The list could not be loaded.",
    "path.editor.practice.instructions": "Instructions",
    "path.editor.practice.placeholder": "Practice this sequence and note how it felt.",
    "path.editor.practice.requireSubmission": "Require submission (text/photo)",
    "path.editor.practice.completesOnSubmit": "Completes when the learner submits text or a photo. Submissions land in your review queue.",
    "path.editor.practice.completesOnDone": "Learner taps “Mark as done”",
    "path.editor.live.dateTime": "Date · time",
    "path.editor.live.zone": "In your time zone ({zone}). Each learner sees it in their own.",
    "path.editor.live.zoneLocal": "In your time zone. Each learner sees it in their own.",
    "path.editor.live.sessionType": "Session type",
    "path.editor.live.chooseSessionType": "Choose a session type",
    "path.editor.live.serviceOption": "{name} · {n} min",
    "path.editor.live.serviceUnavailable": "{name} (no longer offered)",
    "path.editor.live.serviceUnnamed": "Session type",
    "path.editor.live.bookedSeparately": "booked separately",
    "path.editor.live.noServices": "No active session type. Create one in Bookings.",
    "path.editor.live.location": "Location or access (optional)",
    "path.editor.live.locationPh": "Zoom link sent by email, Studio A…",
    "path.editor.live.completesOnAttendance": "Completes when you tick attendance on the pathway dashboard.",
    "path.editor.live.completesOnBooking": "Completes when booking is marked complete",
    "path.editor.course.pick": "Course",
    "path.editor.course.choose": "Choose a published course",
    "path.editor.course.option": "{title} · {n} lessons",
    "path.editor.course.none": "No published course. Publish a course in Courses to add it here.",
    "path.editor.course.locked": "A saved step keeps its course. For another course, remove the step and add a new one.",
    "path.editor.course.missing": "This course no longer exists",
    "path.editor.course.paidWarning": "Learners of this pathway get this course for free.",
    "path.editor.course.completes": "Completes when the learner has finished every lesson of the course.",
    "path.editor.quiz.import": "Import from a course quiz",
    "path.editor.quiz.importChoose": "Choose a quiz",
    "path.editor.quiz.importOption": "{course} · {quiz} ({n} questions)",
    "path.editor.quiz.importRun": "Import",
    "path.editor.quiz.importNone": "None of your courses has a quiz to import.",
    "path.editor.quiz.imported": "{n} questions added at the end of the quiz. It is a copy: editing the course does not change it.",
    "path.editor.quiz.importedOne": "{n} question added at the end of the quiz. It is a copy: editing the course does not change it.",
    "path.editor.quiz.importSkipped": "{n} questions skipped (open questions are not supported)",
    "path.editor.quiz.importSkippedOne": "{n} question skipped (open questions are not supported)",
    "path.editor.quiz.empty": "No questions yet.",
    "path.editor.quiz.questionN": "Q{n}.",
    "path.editor.quiz.questionPh": "Your question…",
    "path.editor.quiz.removeQuestion": "Remove question {n}",
    "path.editor.quiz.choicesOf": "Choices of question {n}",
    "path.editor.quiz.choiceN": "Choice {n}",
    "path.editor.quiz.choicePh": "Choice {n}",
    "path.editor.quiz.markCorrect": "Choice {n} is the correct one",
    "path.editor.quiz.correct": "(correct)",
    "path.editor.quiz.removeChoice": "Remove choice {n}",
    "path.editor.quiz.addChoice": "+ Add choice",
    "path.editor.quiz.addQuestion": "Add question",
    "path.editor.quiz.threshold": "Pass threshold",

    // ── media picker, non-image modes ──
    "media.picker.selectNamed": "Select {name}",
    "media.picker.wrongType": "This file is not an image. It was added to your media library, but not to this field.",
    "media.picker.video.hint": "Select a video or upload a new one.",
    "media.picker.video.upload": "Upload a video",
    "media.picker.video.empty": "No videos in your media library yet. Upload one above.",
    "media.picker.video.wrongType": "This file is not a video. It was added to your media library, but not to this step.",
    "media.picker.pdf.hint": "Select a PDF or upload a new one.",
    "media.picker.pdf.upload": "Upload a PDF",
    "media.picker.pdf.empty": "No PDFs in your media library yet. Upload one above.",
    "media.picker.pdf.wrongType": "This file is not a PDF. It was added to your media library, but not to this reading.",
    "media.picker.resource.hint": "Select a document or an image, or upload a new file.",
    "media.picker.resource.upload": "Upload a file",
    "media.picker.resource.empty": "No documents in your media library yet. Upload one above.",
    "media.picker.resource.wrongType": "This kind of file cannot be offered as a download (PDF, Word, Excel, PowerPoint, text or image).",
  },
  es: {
    // ── step editor ──
    "path.editor.newTitle": "Nuevo paso",
    "path.editor.editTitle": "Editar el paso",
    "path.editor.close": "Cerrar",
    "path.editor.title": "Título",
    "path.editor.duration": "Duración (min)",
    "path.editor.kind": "Tipo de contenido",
    "path.editor.save": "Guardar el paso",
    "path.editor.cancel": "Cancelar",
    "path.editor.confirmDiscard": "¿Cerrar sin conservar los cambios de este paso?",
    "path.editor.remove": "Quitar",
    "path.editor.removeFile": "Quitar {name}",
    "path.editor.unnamedFile": "Archivo",
    "path.editor.resources": "Recursos descargables",
    "path.editor.resourcesOptional": "(opcional)",
    "path.editor.attachFiles": "Adjuntar archivos",
    "path.editor.video.uploadOrLink": "Sube un vídeo o pega un enlace",
    "path.editor.video.upload": "Elegir o subir un vídeo",
    "path.editor.video.uploaded": "Vídeo subido",
    "path.editor.video.link": "o pega un enlace de YouTube o Vimeo",
    "path.editor.video.preview": "Vista previa del vídeo",
    "path.editor.video.autoComplete": "Se completa solo al ver el 90 %",
    "path.editor.reading.mode": "Modo de edición",
    "path.editor.reading.write": "Escribir",
    "path.editor.reading.preview": "Vista previa",
    "path.editor.reading.previewEmpty": "Todavía no hay nada que mostrar.",
    "path.editor.reading.toolbar": "Formato",
    "path.editor.reading.body": "Texto de la lectura",
    "path.editor.reading.tool.bold": "Negrita",
    "path.editor.reading.tool.italic": "Cursiva",
    "path.editor.reading.tool.heading": "Título",
    "path.editor.reading.tool.bullets": "Lista con viñetas",
    "path.editor.reading.tool.link": "Enlace",
    "path.editor.reading.or": "o",
    "path.editor.reading.attachPdf": "Adjuntar un PDF",
    "path.editor.reading.markDone": "El alumno pulsa «Marcar como hecho»",
    "path.editor.kindLocked": "Un paso guardado conserva su tipo. Para otro tipo, quita el paso y añade uno nuevo.",
    "path.editor.catalogueFailed": "No se pudo cargar la lista.",
    "path.editor.practice.instructions": "Instrucciones",
    "path.editor.practice.placeholder": "Practica esta secuencia y anota cómo te sentiste.",
    "path.editor.practice.requireSubmission": "Pedir un envío (texto o foto)",
    "path.editor.practice.completesOnSubmit": "Se completa cuando el alumno envía un texto o una foto. Los envíos llegan a tu cola de revisión.",
    "path.editor.practice.completesOnDone": "El alumno pulsa «Marcar como hecho»",
    "path.editor.live.dateTime": "Fecha · hora",
    "path.editor.live.zone": "En tu zona horaria ({zone}). Cada alumno la ve en la suya.",
    "path.editor.live.zoneLocal": "En tu zona horaria. Cada alumno la ve en la suya.",
    "path.editor.live.sessionType": "Tipo de sesión",
    "path.editor.live.chooseSessionType": "Elegir un tipo de sesión",
    "path.editor.live.serviceOption": "{name} · {n} min",
    "path.editor.live.serviceUnavailable": "{name} (ya no se ofrece)",
    "path.editor.live.serviceUnnamed": "Tipo de sesión",
    "path.editor.live.bookedSeparately": "se reserva aparte",
    "path.editor.live.noServices": "No hay ningún tipo de sesión activo. Crea uno en Reservas.",
    "path.editor.live.location": "Lugar o acceso (opcional)",
    "path.editor.live.locationPh": "Enlace de Zoom enviado por correo, Estudio A…",
    "path.editor.live.completesOnAttendance": "Se completa cuando marcas la asistencia en el panel del itinerario.",
    "path.editor.live.completesOnBooking": "Se completa cuando la reserva se marca como terminada",
    "path.editor.course.pick": "Curso",
    "path.editor.course.choose": "Elegir un curso publicado",
    "path.editor.course.option": "{title} · {n} lecciones",
    "path.editor.course.none": "No hay ningún curso publicado. Publica un curso en Cursos para añadirlo aquí.",
    "path.editor.course.locked": "Un paso guardado conserva su curso. Para otro curso, quita el paso y añade uno nuevo.",
    "path.editor.course.missing": "Este curso ya no existe",
    "path.editor.course.paidWarning": "Los alumnos de este itinerario reciben este curso gratis.",
    "path.editor.course.completes": "Se completa cuando el alumno ha terminado todas las lecciones del curso.",
    "path.editor.quiz.import": "Importar desde un cuestionario de curso",
    "path.editor.quiz.importChoose": "Elegir un cuestionario",
    "path.editor.quiz.importOption": "{course} · {quiz} ({n} preguntas)",
    "path.editor.quiz.importRun": "Importar",
    "path.editor.quiz.importNone": "Ninguno de tus cursos tiene un cuestionario que importar.",
    "path.editor.quiz.imported": "{n} preguntas añadidas al final del cuestionario. Es una copia: editar el curso no la cambia.",
    "path.editor.quiz.importedOne": "{n} pregunta añadida al final del cuestionario. Es una copia: editar el curso no la cambia.",
    "path.editor.quiz.importSkipped": "{n} preguntas omitidas (las preguntas abiertas no se admiten)",
    "path.editor.quiz.importSkippedOne": "{n} pregunta omitida (las preguntas abiertas no se admiten)",
    "path.editor.quiz.empty": "Todavía no hay preguntas.",
    "path.editor.quiz.questionN": "P{n}.",
    "path.editor.quiz.questionPh": "Tu pregunta…",
    "path.editor.quiz.removeQuestion": "Eliminar la pregunta {n}",
    "path.editor.quiz.choicesOf": "Respuestas de la pregunta {n}",
    "path.editor.quiz.choiceN": "Respuesta {n}",
    "path.editor.quiz.choicePh": "Respuesta {n}",
    "path.editor.quiz.markCorrect": "La respuesta {n} es la correcta",
    "path.editor.quiz.correct": "(correcta)",
    "path.editor.quiz.removeChoice": "Quitar la respuesta {n}",
    "path.editor.quiz.addChoice": "+ Añadir una respuesta",
    "path.editor.quiz.addQuestion": "Añadir una pregunta",
    "path.editor.quiz.threshold": "Umbral de aprobado",

    // ── media picker, non-image modes ──
    "media.picker.selectNamed": "Elegir {name}",
    "media.picker.wrongType": "Este archivo no es una imagen. Se ha añadido a tu biblioteca, pero no a este campo.",
    "media.picker.video.hint": "Elige un vídeo o sube uno nuevo.",
    "media.picker.video.upload": "Subir un vídeo",
    "media.picker.video.empty": "Todavía no hay vídeos en tu biblioteca. Sube uno arriba.",
    "media.picker.video.wrongType": "Este archivo no es un vídeo. Se ha añadido a tu biblioteca, pero no a este paso.",
    "media.picker.pdf.hint": "Elige un PDF o sube uno nuevo.",
    "media.picker.pdf.upload": "Subir un PDF",
    "media.picker.pdf.empty": "Todavía no hay PDF en tu biblioteca. Sube uno arriba.",
    "media.picker.pdf.wrongType": "Este archivo no es un PDF. Se ha añadido a tu biblioteca, pero no a esta lectura.",
    "media.picker.resource.hint": "Elige un documento o una imagen, o sube un archivo nuevo.",
    "media.picker.resource.upload": "Subir un archivo",
    "media.picker.resource.empty": "Todavía no hay documentos en tu biblioteca. Sube uno arriba.",
    "media.picker.resource.wrongType": "Este tipo de archivo no se puede ofrecer como descarga (PDF, Word, Excel, PowerPoint, texto o imagen).",
  },
};
